/* Load once when real payment markup appears; inspect changes, not the entire page. */
(() => {
  "use strict";
  if (window.gpPaymentWidgetsStarted) return;
  window.gpPaymentWidgetsStarted = true;
  const widgets = [
    {
      selector: "square-placement, [data-afterpay-modal]",
      src: "https://js.squarecdn.com/square-marketplace.js",
    },
    {
      selector: "[data-zm-asset], [zm-asset]",
      src: "https://static.zip.co/lib/js/zm-widget-js/dist/zip-widget.min.js",
    },
  ];
  const targets = new WeakMap();
  const visibility = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const widget = targets.get(entry.target);
      if (!widget || widget.started) return;
      visibility.unobserve(entry.target);
      widget.started = true;
      if ([...document.scripts].some((script) => script.src === widget.src)) return;
      const script = document.createElement('script');
      script.src = widget.src;
      script.async = true;
      document.head.appendChild(script);
    });
    if (widgets.every((widget) => widget.started)) {
      observer.disconnect();
      visibility.disconnect();
    }
  }, {rootMargin: '200px 0px'});
  function inspect(root) {
    if (!root.querySelector) return;
    widgets.forEach((widget) => {
      if (widget.started) return;
      const matches = [...root.querySelectorAll(widget.selector)];
      if (root.matches?.(widget.selector)) matches.unshift(root);
      matches.forEach((element) => {
        if (targets.has(element)) return;
        targets.set(element, widget);
        visibility.observe(element);
      });
    });
  }
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === "attributes") inspect(record.target);
      else record.addedNodes.forEach(inspect);
    });
    if (widgets.every((widget) => widget.started)) observer.disconnect();
  });
  inspect(document);
  if (!widgets.every((widget) => widget.started))
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-zm-asset", "zm-asset", "data-afterpay-modal"],
    });
})();
